import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const columns = [
  {
    title: 'Order Number and Date',
    dataIndex: 'order_number',
    key: 'order_number',
    scopedSlots: { customRender: 'order_number' },
    width: 200,
  },
  {
    title: 'Customer Name',
    dataIndex: 'customer_name',
    key: 'customer_name',
    scopedSlots: { customRender: 'customer_name' },
    class: 'text-center',
    width: 150,
  },
  {
    title: 'Shipment Area',
    dataIndex: 'shipment',
    key: 'shipment',
    scopedSlots: { customRender: 'shipment' },
    class: 'text-center',
    width: 150,
  },
  {
    title: 'Channel',
    dataIndex: 'channel_name',
    key: 'channel_name',
    class: 'text-center',
  },
  {
    title: 'Total Payment',
    dataIndex: 'order_total',
    key: 'order_total',
    scopedSlots: { customRender: 'order_total' },
    width: 150,
    class: 'text-center',
  },
  {
    title: 'Status',
    dataIndex: 'order_state',
    key: 'order_state',
    scopedSlots: { customRender: 'order_state' },
    width: 100,
    class: 'text-center',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: { customRender: 'actions' },
    width: 150,
    class: 'text-center',
  },
]

const state = {
  isLoadingOrders: false,
  salesOrders: [],
  orderDetail: null,
  columns,
  isLoadingTable: false,
  pagination: {},
  paginateParams: [],
  tableActive: null,
  rangeDate: [],
  valueSearching: '',
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
